import React, { useCallback } from "react";
import { useDispatch } from "react-redux";

import {
  toggleBuyInternetTimeModal,
  toggleResponseInternetTimeModal,
} from "../actions/actions";
import { updateBalance } from "../api/update-balance";
import { IButtonHandler } from "../components/Modal/types";

export const useRequestBuyTime = (): IButtonHandler => {
  const dispatch = useDispatch();

  const handleBuyTime = useCallback(
    async (event: React.SyntheticEvent<HTMLDivElement>, amount: number) => {
      event.preventDefault();
      const resp = await updateBalance({ amount });

      if (!resp || resp instanceof Error) {
        dispatch(toggleResponseInternetTimeModal(true, true));
      } else {
        dispatch(toggleResponseInternetTimeModal(true, false));
      }

      dispatch(toggleBuyInternetTimeModal(false));
    },
    [dispatch]
  );

  return { handleBuyTime };
};
